

/**no imports because this file is loaded in both browser and nodejs environment */

module.exports = {
    injectInMainCssTemplate,
    getCssForShapeId,
}


function injectInMainCssTemplate(cssMainRawText, options, fontsData) {
    const {
        logoImage,
        logoHidden,
        backgroundColor,
        backgroundImage,
        backgroundImageOpacity,
        backgroundImageMobile,
        backgroundImageMobileLimit,

        heading1,
        heading2,
        heading3,
        menu,
        text,

        primaryText,
        secondaryText,

        primaryAccent,
        secondaryAccent,

        buttonOptions,
    } = options

    cssMainRawText = cssMainRawText.replace(/__inject_fonts__/g, fontsData)
    cssMainRawText = cssMainRawText.replace(/__inject_logo_image__/g, logoImage)
    cssMainRawText = cssMainRawText.replace(/__inject_logo_visibility__/g, logoHidden ? "none" : "unset")
    cssMainRawText = cssMainRawText.replace(/__inject_background_color__/g, backgroundColor)
    cssMainRawText = cssMainRawText.replace(/__inject_background_image__/g, backgroundImage)
    cssMainRawText = cssMainRawText.replace(/__inject_background_image_opacity__/g, backgroundImageOpacity)
    cssMainRawText = cssMainRawText.replace(/__inject_background_image_mobile__/g, backgroundImageMobile)
    cssMainRawText = cssMainRawText.replace(/__inject_background_image_mobile_limit__/g, backgroundImageMobileLimit)

    cssMainRawText = cssMainRawText.replace(/__inject_primary_color__/g, primaryAccent)
    cssMainRawText = cssMainRawText.replace(/__inject_secondary_color__/g, secondaryAccent)

    cssMainRawText = cssMainRawText.replace(/__inject_primary_text_color__/g, primaryText)
    cssMainRawText = cssMainRawText.replace(/__inject_secondary_text_color__/g, secondaryText)

    cssMainRawText = cssMainRawText.replace(/__inject_text_font__/g, text.fontFamily)
    cssMainRawText = cssMainRawText.replace(/__inject_text_font_size__/g, text.fontSize)

    cssMainRawText = cssMainRawText.replace(/__inject_text_menu_font__/g, menu.fontFamily)
    cssMainRawText = cssMainRawText.replace(/__inject_text_menu_font_size__/g, menu.fontSize)

    cssMainRawText = cssMainRawText.replace(/__inject_h1_font__/g, heading1.fontFamily)
    cssMainRawText = cssMainRawText.replace(/__inject_h1_font_size__/g, heading1.fontSize)

    cssMainRawText = cssMainRawText.replace(/__inject_h2_font__/g, heading2.fontFamily)
    cssMainRawText = cssMainRawText.replace(/__inject_h2_font_size__/g, heading2.fontSize)

    cssMainRawText = cssMainRawText.replace(/__inject_h3_font__/g, heading3.fontFamily)
    cssMainRawText = cssMainRawText.replace(/__inject_h3_font_size__/g, heading3.fontSize)


    // BUTTON OPTIONS
    const { shape, defaultShape } = buttonOptions
    const { textColor, backgroundColor: buttonBackgroundColor, borderColor } = buttonOptions
    const { textColorHover, backgroundColorHover, borderColorHover } = buttonOptions

    const buttonCssText = getCssForShapeId(shape || defaultShape, buttonBackgroundColor, textColor, borderColor)
    const buttonHoverCssText = getCssForShapeId(shape || defaultShape, backgroundColorHover, textColorHover, borderColorHover)

    cssMainRawText = cssMainRawText.replace(/__inject_button_css__/g, buttonCssText)
    cssMainRawText = cssMainRawText.replace(/__inject_button_hover__/g, buttonHoverCssText)
    cssMainRawText = cssMainRawText.replace(/__inject_button_text_color__/g, textColor)

    return cssMainRawText
}

function getCssForShapeId(shapeId, backgroundColor, textColor, borderColor) {
    switch (shapeId) {

        // RECTANGLE
        case '1': {
            return `border-radius: 0px !important;
            background-color: ${backgroundColor} !important;
            color: ${textColor} !important;
            border-color: ${borderColor} !important;
            `
        }

        //  ROUNDED RECTANGLE 
        case '2': {
            return `border-radius: 5px !important;
            background-color: ${backgroundColor} !important;
            color: ${textColor} !important;
            border-color: ${borderColor} !important;
            `
        }

        // CAPSULE
        case '3': {
            return `border-radius: 30px !important;
            background-color: ${backgroundColor} !important;
            color: ${textColor} !important;
            border-color: ${borderColor} !important;
            `
        }

        // OUTLINED RECTANGLE
        case '4': {
            return `border-radius: 0px !important;
            background-color: unset !important;
            color: ${textColor} !important;
            border-color: ${borderColor} !important`
        }

        // OUTLINED ROUNDED RECTANGLE
        case '5': {
            return `border-radius: 15px !important;
            background-color: unset !important;
            color: ${textColor} !important;
            border-color: ${borderColor} !important`;
        }

        // OUTLINED CAPSULE
        case '6': {
            return `border-radius: 30px !important;
            background-color: unset !important;
            color: ${textColor} !important;
            border-color: ${borderColor} !important;
            `
        }

        // TEXTUAL
        case '7': {
            return `border-color: transparent !important;
            color: ${textColor} !important;
            background-color: unset !important;
            `
        }

        // WAT ???
        case '8': {
            return `border-radius: 50px !important;
            border: none !important;
            color: ${textColor} !important;
            background-color: ${borderColor} !important;
            `
        }
        case '9': {
            return `border-radius: 5px !important;
            border: none !important;
            color: ${textColor} !important;
            background-color: ${borderColor} !important;
            `
        }
        ////////////////////////////////

    }
}
